import { render, staticRenderFns } from "./LocalisationProvidersMobileModal.vue?vue&type=template&id=41fdff4a&"
import script from "./LocalisationProvidersMobileModal.vue?vue&type=script&lang=ts&"
export * from "./LocalisationProvidersMobileModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports